export default "__VITE_ASSET__BHAQD1YJ__"